module.exports = new __parcel__URL__("sql.dcf506fc.svg").toString();